import React from "react";
import { ACCENT } from "../artistStudio/shared";

// The waveform of a sound: one bar per value in `peaks` (0-100, from the server's audio analysis). Bars up to `progress` (0-1) are
// drawn in the accent colour. Clicking jumps to that point when `onSeek` is given (it gets a fraction 0-1); keyboard users seek with
// the player's own slider.
export default function Waveform({ peaks, progress = 0, onSeek, label = "Waveform" }) {
  if (!Array.isArray(peaks) || peaks.length === 0) return null;
  const played = Math.max(0, Math.min(1, Number(progress) || 0)) * peaks.length;
  const click = (e) => {
    if (!onSeek) return;
    const box = e.currentTarget.getBoundingClientRect();
    if (!box.width) return;
    onSeek(Math.max(0, Math.min(1, (e.clientX - box.left) / box.width)));
  };
  return (
    <div
      role="img" aria-label={label} data-testid="waveform" onClick={click}
      className={`mt-5 flex h-14 items-center gap-px ${onSeek ? "cursor-pointer" : ""}`}
    >
      {peaks.map((p, i) => (
        <span
          key={i} data-testid="waveform-bar" data-played={i < played ? "true" : "false"}
          className="flex-1 rounded-full" style={{ height: `${Math.max(6, Math.min(100, Number(p) || 0))}%`, backgroundColor: i < played ? ACCENT : "#d1d5db" }}
        />
      ))}
    </div>
  );
}
